// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19pk1b66{margin-top:var(--ds-space-050,4px)}\n._19pk1jfw{margin-top:var(--ds-space-500,40px)}\n._1e0c1ule{display:block}\n._c71lplmo{max-height:156px}\n._otyr1ejb{margin-bottom:var(--ds-space-300,24px)}\n._p12f1gwv{max-width:360px}\n._p12f7iqz{max-width:87pt}\n._y3gn1h6o{text-align:center}", ""]);
// Exports
module.exports = exports;
